import { Badge, Flex, Text } from "@radix-ui/themes";

import { Loader } from "@/components/ui/loader";
import { RegressionSetBySimulatorId } from "@/v2/entities/regression/Regression.model";
import { formatDate } from "./utils";
import styles from "./styles.module.scss";

interface SetsViewProps {
  regressionSets: RegressionSetBySimulatorId[] | undefined;
  isLoading: boolean;
  onSelectSet: (id: string) => void;
}

export function SetsView({
  regressionSets,
  isLoading,
  onSelectSet,
}: SetsViewProps) {
  return (
    <>
      <div className={styles.panelHeader}>
        <Flex align="center" gap="2">
          <Text size="3" weight="medium">
            Test Sets
          </Text>
          <Badge color="gray">{regressionSets?.length ?? 0}</Badge>
        </Flex>
      </div>

      <div className={styles.panelContent}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <Loader />
          </div>
        ) : regressionSets && regressionSets.length > 0 ? (
          regressionSets.map((set) => (
            <div
              key={set.id}
              className={styles.listItem}
              onClick={() => onSelectSet(set.id)}
            >
              <Flex direction="column" gap="1">
                <Text size="2" weight="medium">
                  {set.name}
                </Text>
                <Flex align="center" gap="2">
                  <Text size="1" color="gray">
                    {set.numberOfConversations} items
                  </Text>
                  {set.mostRecentTest && (
                    <>
                      <Text size="1" color="gray">
                        •
                      </Text>
                      <Text size="1" color="gray">
                        {formatDate(set.mostRecentTest.runTime)}
                      </Text>
                      {set.mostRecentTest.avgAccuracy != null && (
                        <Badge
                          size="1"
                          color={
                            set.mostRecentTest.avgAccuracy >= 0.8
                              ? "green"
                              : set.mostRecentTest.avgAccuracy >= 0.5
                              ? "orange"
                              : "red"
                          }
                        >
                          {Math.round(set.mostRecentTest.avgAccuracy * 100)}%
                        </Badge>
                      )}
                    </>
                  )}
                </Flex>
              </Flex>
            </div>
          ))
        ) : (
          <div className={styles.emptyState}>
            <Text size="2" color="gray">
              No regression test sets yet
            </Text>
          </div>
        )}
      </div>
    </>
  );
}
